/* eslint-disable camelcase */
export enum PanelTypes {
  SHOW_REQUEST = '@panel/SHOW_REQUEST',
  SHOW_SUCCESS = '@panel/SHOW_SUCCESS',
  SHOW_FAILURE = '@panel/SHOW_FAILURE',
  SEND_FEEDBACK_REQUEST = '@panel/SEND_FEEDBACK_REQUEST',
  SEND_FEEDBACK_SUCCESS = '@panel/SEND_FEEDBACK_SUCCESS',
  SEND_FEEDBACK_FAILURE = '@panel/SEND_FEEDBACK_FAILURE',
  SHOW_DASHBOARD = '@panel/SHOW_DASHBOARD',
  UPDATE_STATUS_REGISTER_MODAL = '@panel/UPDATE_STATUS_REGISTER',
  UPDATE_STATUS_REGISTER_EXPERIENT_MODAL = '@panel/UPDATE_STATUS_REGISTER_EXPERIENT_MODAL',
  SHOW_PRIZE_ROULLETE = '@panel/SHOW_PRIZE_ROULLETE',
  SET_PRIZE = '@panel/SET_PRIZE',
  SHOW_25_ANOS = '@panel/SHOW_25_ANOS',
  SHOW_MODAL_IA = '@panel/SHOW_MODAL_IA',
}
export interface shortcuts {
  checked: boolean;
  created_at: string;
  default: true;
  icon: string;
  id: number;
  link: string;
  name: string;
  updated_at: string;
  category: string;
  tag_new: boolean;
}

export interface beebeeate_portals {
  source_id: number;
  portal_name: string;
}

export interface PanelData {
  show_expiration_alert: boolean;
  allow_robot: boolean;
  days_to_end: number;
  partner_id: number | false;
  four_months_left_to_renew: boolean;
  robo_access: boolean;
  dr_licita_access: boolean;
  representant_access: boolean;
  banner_robo_access: boolean;
  banner_new_robo_access: boolean;
  registration_type_validation: number;
  view_modal_experient: boolean;
  validate_services: {
    gerenciar_documentos: boolean;
    monitorar_chat: boolean;
    assinatura_digital: boolean;
    robo: boolean;
    conlicitago: boolean;
    course_iaml: boolean;
    dr_licita: boolean;
  };
  view_panel: string;
  view_modal_register: boolean;
  view_modal_experient_status: boolean;
  renewal_plans: boolean;
  course_released: boolean;
  bid_winner: {
    winner: boolean;
    edital: string;
    orgao_nome: string;
    contato_nome: string;
  };
  renewal_campaign: {
    released_online: boolean;
    contact_name: string;
    campaign_phase: number;
    subscription_end_date: string;
    view_modal: boolean;
  };
  list_tools_shortcuts: Array<shortcuts>;
  evaluated: boolean;
  return_package: string;
  show_prize_roulette: boolean;
  modal_25_anos: boolean;
  prize: any;
  roulette_elegible: boolean;
  roulette_header: boolean;
  modal_ia: boolean;
  view_modal_search: boolean;
  beebeeate_portals: Array<beebeeate_portals>;
  services_paralyzed: {
    gerenciar_documentos: boolean;
    monitorar_chat: boolean;
    assinatura_digital: boolean;
    robo: boolean;
    conlicitago: boolean;
    course_iaml: boolean;
    dr_licita: boolean;
  };
}
export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface PanelState {
  readonly panel: PanelData;
  readonly request: RequestState;
  readonly request_send_feedback: RequestState;
}
